module.exports = __webpack_public_path__ + "static/img/4_4_1.9bc90798.jpg";